<template>
  <div id="sideMenu">
    <menu-brand />
    <div class="main-side-menu">
      <select-branch />
      <list-menu-new />
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import SelectBranch from "./select-branch";
import ListMenuNew from "./list-menu-new";
import MenuBrand from "./menu-brand";

export default {
  name: "main-menu",
  data() {
    return {};
  },
  components: {
    MenuBrand,
    ListMenuNew,
    SelectBranch,
    VuePerfectScrollbar,
    listMenu: () => import("./list-menu.vue"),
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/menu-left/main-menu.vue